export class PaymentIntegration{
    public paymentIntegrationId:number;
    public paymentType:String;
    public frontEndSuccessUrl:String;
    public frontEndFailureUrl:String;
    public currency:String;
    public receiptName:String;
    public apiAfterSuccess:String;
    public orderId:number;
    public razorpayPaymentUrl:string;
    public razorpayPublicKey:string;
    public redirectUrl:string;
}
